import React from "react";
import { Button } from "@mui/material";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import { Link } from "@mui/material";

export default function Landing(){

  const navigate = useNavigate()

  return (
    <div className="landing-container">
      <div className="landing-header">
        <div className="landing-title">
          PaperPusher
        </div>
          <img className="landing-logo" src={require("../../airplane.png")} alt="" />
      </div>
      <div className="home-container">
        <h1 className="landing-heading">More shows, <span className="less">less</span> paperwork</h1>
        <p className="landing-tag">Streamline your artist's bookings and do way less paperwork.</p>
      <PaperButton onClick={() => navigate("/register")}>Sign Up</PaperButton>
      <Link sx={{textDecoration: 'none', cursor: 'pointer'}} onClick={() => navigate("/")}><p className="log-in-text">Log In</p></Link>
      </div>
    </div>
  )
}

const PaperButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  padding: '6px 12px',
  border: 'none',
  lineHeight: 1.5,
  color: 'rgba(33,37,61,1)',
  backgroundColor: 'rgba(255,124,124,1)',
  border: '2px solid rgba(255,124,124,1)',
  fontFamily:'Josefin Sans',
  '&:hover': {
    backgroundColor: 'rgba(33,37,61,1)',
    borderColor: 'rgba(255,124,124,1)',
    border: '2px solid rgba(255,124,124,1)',
    boxShadow: 'none',
    color:'rgba(255,124,124,1)'
  },
  '&:active': {
    boxShadow: 'none',
    borderColor: 'rgba(255,124,124,1)',
  },
  '&:focus': {
    boxShadow: '0 0 0 0.2rem rgba(255,124,124,1)',
    borderColor: 'rgba(255,124,124,1)',
  },
});